import './polyfills';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { FlagsProvider } from 'flagged';
import { Provider } from 'react-redux';
import store from './store/store';

import * as serviceWorker from './serviceWorker';
import { LanguageProvider } from './components/languages';
import App from './components/App';
import awsConfig from './aws-exports';
import { fetchAppConfigByProfileName } from './components/common/Appconfig';
import { getHighlightsLabel } from './utils/highlightsLabel';

const getFaviconUrl = (accountName) => {
	const lowerAccountName = accountName.toLowerCase();
	if (lowerAccountName.includes('peacock')) return `${process.env.PUBLIC_URL}/favicons/peacock-favicon.png`;
	if (lowerAccountName.includes('wow')) return `${process.env.PUBLIC_URL}/favicons/wow-favicon.png`;
	if (lowerAccountName.includes('now')) return `${process.env.PUBLIC_URL}/favicons/now-favicon.png`;
	return `${process.env.PUBLIC_URL}/favicons/sky-favicon.png`;
};

document.title = `${getHighlightsLabel(awsConfig.accountName)} Service`;
document.querySelector("link[rel='shortcut icon']").setAttribute('href', getFaviconUrl(awsConfig.accountName));

const AppComponent = () => {
	useEffect(() => {
		const getAppConfigs = async () => {
			const mgmtUiAppconfigConfigsProfile = await fetchAppConfigByProfileName('mgmt_ui_appconfig_configs_profile');
			if (!mgmtUiAppconfigConfigsProfile) {
				return;
			}
			const mgmtUiConfigs = JSON.parse(mgmtUiAppconfigConfigsProfile);
			if (mgmtUiConfigs['featureFlags'])
				setFeatureFlags(mgmtUiConfigs['featureFlags'][awsConfig.accountName] ?? mgmtUiConfigs['featureFlags']['development'] ?? {});
		};
		getAppConfigs();
	}, []);
	const [featureFlagsConfig, setFeatureFlags] = useState({});

	return (
		<Provider store={store}>
			<FlagsProvider features={featureFlagsConfig}>
				<LanguageProvider>
					<App />
				</LanguageProvider>
			</FlagsProvider>
		</Provider>
	);
};

ReactDOM.render(
	<BrowserRouter>
		<AppComponent />
	</BrowserRouter>,
	document.querySelector('#root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
